import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e22b8774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-relative row flex-column vh-lg-100 g-0 columns justify-content-center align-content-center py-4" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex position-absolute w-100 h-100 align-items-center justify-content-center",
  style: {"background-color":"rgba(255, 255, 255, 0.5)"}
}
const _hoisted_3 = { class: "d-block text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1))
const _hoisted_5 = { class: "col-11 col-md-8 col-lg-5 border p-4 rounded" }
const _hoisted_6 = { key: "incomplete" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title text-center fw-bold my-3" }, "Registro", -1))
const _hoisted_8 = { class: "row gy-3" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = {
  key: 0,
  class: "row my-3 mt-5"
}
const _hoisted_11 = { class: "col-6 col-md-6 d-flex justify-content-center" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-md-6 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn",
    type: "submit"
  }, "Verificar")
], -1))
const _hoisted_14 = {
  key: 1,
  class: "row"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-2 mb-4 text-danger fw-bold" }, " El email ya se encuentra en uso, inicie sesión o recupere su contraseña en caso de no recordarla ", -1))
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_18 = { class: "col-12 col-md-12 d-flex justify-content-between align-items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  type: "submit"
}, "Iniciar sesion", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_21 = { class: "row gy-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-5 mb-3 h4 text-center" }, " Completá con tus datos personales ", -1))
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "col-md-12" }
const _hoisted_26 = { class: "col-md-12" }
const _hoisted_27 = { class: "row my-3 mt-4" }
const _hoisted_28 = { class: "col-6 col-md-6 d-flex justify-content-center" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "col-6 col-md-6 d-flex justify-content-center" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  class: "text-center",
  key: "complete"
}

import { reactive, ref, watch } from 'vue'
import FormName from '@/components/form/FormName.vue'
import FormEmail from '@/components/form/FormEmail.vue'
import FormDni from '@/components/form/FormDni.vue'
import FormPassword from '@/components/form/FormPassword.vue'
import VipUser from '@/components/form/VipUser.vue'
import router from '@/router'
import { Form, useForm } from 'vee-validate'
import { userService } from '@/services/user.service'
import useLoading from '@/composables/useLoading'
import { useStore } from 'vuex'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { loginService } from '@/services/login.service'
import { useToast } from 'vue-toastification'


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterFidelizacion',
  setup(__props) {

const { commit, state } = useStore<VuexStore>(key)
const { loading, setSearch } = useLoading(false)
const complete = ref<boolean | string>(false)
const form = reactive({
  nombre: '',
  apellido: '',
  email: '',
  documento: '',
  documentacion: {
    vin: '',
    modelo: '',
    clasico: false,
    imagenCedulaFrente: '',
    imagenCedulaDorso: '',
    isClient: null
  }
})

const toast = useToast()
const { handleSubmit } = useForm()
const emailValidado = ref<number | null>(null)
const password = ref<string>('')

const backClick = () => {
  router.go(-1)
}

const validateEmail = handleSubmit(async () => {
  try {
    if (password.value !== '') {
      setSearch(true, 'Iniciando sesión')
      const user = await loginService.ingresar(form.email, password.value)
      commit('SET_USER', user)
      toast.success('Iniciaste sesión ' + user.nombre + ' ' + user.apellido)
      const url = state.returnUrl ?? { name: 'Home' }
      await router.push(url)
      return
    }

    setSearch(true, 'Validando email')
    await userService.validarEmail(form.email)
    emailValidado.value = 1
    setSearch(false, '')
  } catch (e) {
    setSearch(false)
    emailValidado.value = -1
  }
})

const submitForm = handleSubmit(async () => {
  try {
    setSearch(true, 'Registrando usuario')
    let msj = ''
    if (form.documentacion.isClient === null) {
      msj = await userService.registrar({
        nombre: form.nombre,
        apellido: form.apellido,
        email: form.email,
        documento: form.documento
      })
    } else {
      msj = await userService.registrar(form)
    }

    setSearch(false, '')
    complete.value = msj
    if (state.navigation.complete) {
      commit('RESET_NAV')
    }
  } catch (e) {
    setSearch(false)
  }
})

watch(
  () => form.email,
  () => {
    if (emailValidado.value === -1) {
      emailValidado.value = null
      password.value = ''
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(loading).status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h6", null, _toDisplayString(_unref(loading).text), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (!complete.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_unref(Form), { onSubmit: _unref(validateEmail) }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(FormEmail, {
                      modelValue: form.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
                      disabled: emailValidado.value === 1
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ]),
                (emailValidado.value === null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn",
                          onClick: _withModifiers(backClick, ["prevent"])
                        }, " Salir ", 8, _hoisted_12)
                      ]),
                      _hoisted_13
                    ]))
                  : _createCommentVNode("", true),
                (emailValidado.value == -1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(FormPassword, {
                          modelValue: password.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_router_link, { to: { name: 'Recovery' } }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Recuperar contraseña ")
                          ]),
                          _: 1
                        }),
                        _hoisted_19
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onSubmit"]),
            (emailValidado.value == 1)
              ? (_openBlock(), _createBlock(_unref(Form), {
                  key: 0,
                  onSubmit: _unref(submitForm)
                }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(FormName, {
                          label: "formularios.nombre.label",
                          placeholder: "formularios.nombre.placeholder",
                          modelValue: form.nombre,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.nombre) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(FormName, {
                          label: "formularios.apellido.label",
                          placeholder: "formularios.apellido.placeholder",
                          modelValue: form.apellido,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.apellido) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(FormDni, {
                          label: "formularios.dni.label",
                          placeholder: "formularios.dni.placeholder",
                          modelValue: form.documento,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.documento) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(VipUser, {
                          title: `Registra tu ${_unref(state).evento?.marca}`,
                          descripcion: `Para ser miembro de ${_unref(state).evento?.nombre} debés registrar al menos un vehículo ${_unref(state).evento?.marca} del que seas titular. Para validarlo te pedimos que completes la siguiente información.`,
                          documento: form.documento,
                          modelValue: form.documentacion,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.documentacion) = $event)),
                          required: false
                        }, null, 8, ["title", "descripcion", "documento", "modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn",
                          onClick: _withModifiers(backClick, ["prevent"])
                        }, " Salir ", 8, _hoisted_29)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("button", {
                          class: "btn",
                          disabled: 
                  !(
                    Boolean(form.documento) &&
                    Boolean(form.nombre) &&
                    Boolean(form.apellido) &&
                    form.documentacion.isClient === null  &&
                    !Boolean(form.documentacion.vin) &&
                    !Boolean(form.documentacion.modelo)
                  ) &&
                  !(
                    Boolean(form.documento) &&
                    Boolean(form.nombre) &&
                    Boolean(form.apellido) &&
                    Boolean(form.documentacion.vin) &&
                    Boolean(form.documentacion.modelo) &&
                    form.documentacion.isClient === false &&
                    Boolean(form.documentacion.imagenCedulaFrente) &&
                    Boolean(form.documentacion.imagenCedulaDorso)
                  ) &&
                  !(
                    Boolean(form.documento) &&
                    Boolean(form.nombre) &&
                    Boolean(form.apellido) &&
                    Boolean(form.documentacion.vin) &&
                    Boolean(form.documentacion.modelo) &&
                    form.documentacion.isClient === true &&
                    !Boolean(form.documentacion.imagenCedulaFrente) &&
                    !Boolean(form.documentacion.imagenCedulaDorso)
                  )
                ,
                          type: "submit"
                        }, " Registrar ", 8, _hoisted_31)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("h3", null, _toDisplayString(complete.value), 1),
            _createElementVNode("h6", null, " Te enviamos un email a \"" + _toDisplayString(form.email) + "\" que te permitirá completar el registro ", 1)
          ]))
    ])
  ]))
}
}

})